// Medium — controlled vocabulary for an artwork's materials.
// Enum values are stable UPPER_SNAKE tokens; user-facing labels live in MEDIUM_DISPLAY.
export enum Medium {
    OilOnCanvas = 'OIL_ON_CANVAS',
    OilOnLinen = 'OIL_ON_LINEN',
    OilOnWoodPanel = 'OIL_ON_WOOD_PANEL',
    OilOnBoard = 'OIL_ON_BOARD',
    PastelOnPaper = 'PASTEL_ON_PAPER',
    PastelOnWoodPanel = 'PASTEL_ON_WOOD_PANEL',
    MixedMediaOnWatercolorPaper = 'MIXED_MEDIA_ON_WATERCOLOR_PAPER',
    AcrylicInkOnPaper = 'ACRYLIC_INK_ON_PAPER',
    AcrylicInkGouacheOnPaper = 'ACRYLIC_INK_GOUACHE_ON_PAPER',
    AcrylicPastelCharcoalOnCanvas = 'ACRYLIC_PASTEL_CHARCOAL_ON_CANVAS',
    AcrylicPastel = 'ACRYLIC_PASTEL',
    CharcoalPencilGouacheOnPaper = 'CHARCOAL_PENCIL_GOUACHE_ON_PAPER',
    InkGouacheOnPaper = 'INK_GOUACHE_ON_PAPER',
    PastelCharcoalOnPaper = 'PASTEL_CHARCOAL_ON_PAPER',
}

export const MEDIUM_DISPLAY: Record<Medium, string> = {
    [Medium.OilOnCanvas]: 'Oil on Canvas',
    [Medium.OilOnLinen]: 'Oil on Linen',
    [Medium.OilOnWoodPanel]: 'Oil on Wood Panel',
    [Medium.OilOnBoard]: 'Oil on Board',
    [Medium.PastelOnPaper]: 'Pastel on Paper',
    [Medium.PastelOnWoodPanel]: 'Pastel on a Wooden Panel',
    [Medium.MixedMediaOnWatercolorPaper]: 'Mixed Media on Watercolor Paper',
    [Medium.AcrylicInkOnPaper]: 'Acrylic, Ink Pen on Paper',
    [Medium.AcrylicInkGouacheOnPaper]: 'Acrylic, Ink Pen, Gouache on Paper',
    [Medium.AcrylicPastelCharcoalOnCanvas]: 'Acrylic, Pastel, Charcoal on Canvas',
    [Medium.AcrylicPastel]: 'Acrylic, Pastel',
    [Medium.CharcoalPencilGouacheOnPaper]: 'Charcoal, Pencil, Gouache on Paper',
    [Medium.InkGouacheOnPaper]: 'Ink Pen, Gouache on Paper',
    [Medium.PastelCharcoalOnPaper]: 'Pastel, Charcoal on Paper',
};
